import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { CountdownTimer } from './components/CountdownTimer';
import { CopiesCounter } from './components/CopiesCounter';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { UMPSection } from './components/UMPSection';
import { ProductSection } from './components/ProductSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0e1a] text-[#f3f4f6] font-sans overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <Header data-id="element-2" />
      <CountdownTimer data-id="element-3" />
      <CopiesCounter data-id="element-4" />

      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <UMPSection data-id="element-8" />
        <ProductSection data-id="element-9" />
        <WhoIsForSection data-id="element-10" />
        <HowItWorksSection data-id="element-11" />
        <ProofSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <PricingSection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
      <RecentPurchaseNotification data-id="element-16" />
    </div>;
}